import axios from 'axios';
import { selectCurrentToken, selectRefreshToken, setCredentials, logOut } from '../redux/authSlice';
import store from '../store';

// Axios instance for authenticated requests
export const axiosAuth = axios.create({
  baseURL: 'https://api-23mxp.ondigitalocean.app/',
});

// Function to refresh the token
const refreshTokenFunction = async (refreshToken) => {
  try {
    const response = await axios.post(
      'https://api-23mxp.ondigitalocean.app/auth/refresh',
      {},
      {
        headers: {
          'Authorization': `Bearer ${refreshToken}`
        }
      }
    );
    const { accessToken, refreshToken: newRefreshToken } = response.data;

    store.dispatch(setCredentials({ accessToken, refreshToken: newRefreshToken }));
    return accessToken;
  } catch (error) {
    console.error('Error refreshing token:', error);
    store.dispatch(logOut());
    throw error;
  }
};

// Request interceptor
axiosAuth.interceptors.request.use(
  (config) => {
    const authToken = selectCurrentToken(store.getState());
    if (authToken) {
      config.headers['Authorization'] = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosAuth.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error?.config;

    if (!originalConfig || originalConfig._retry) {
      return Promise.reject(error);
    }

    // Check for 401 (Unauthorized) status
    if (error.response?.status === 403) {
      originalConfig._retry = true;

      try {
        const refreshToken = selectRefreshToken(store.getState());
        if (!refreshToken) {
          store.dispatch(logOut());
          return Promise.reject(new Error('No refresh token available'));
        }

        const newAccessToken = await refreshTokenFunction(refreshToken);
        originalConfig.headers['Authorization'] = `Bearer ${newAccessToken}`;
        
        return axiosAuth(originalConfig);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosAuth;
